import {
  FranchiseType,
  ProductCategoryType,
  PropositionAllocation,
} from "@hubcapp/types";

/*
In the UI, we group area coverage by franchise type rather than
by product category (as it is defined in the DB).
The DB stores regional pricing, instructor pricing and discounts
by product category so we need to fetch said data via a product category.
This method gets the default product category for a franchise, as decided
by the Product team
*/
export const getDefaultFranchiseProductCategory = (
  franchise: PropositionAllocation,
) => {
  const propositionType = franchise.proposition.type;
  if (propositionType === FranchiseType.Dit) {
    return ProductCategoryType.DitCar;
  }

  if (propositionType === FranchiseType.Motability) {
    const motabilityCategories =
      franchise.proposition.productCategories?.filter(
        category =>
          typeof category.type === "string" &&
          /^Motability\d{4}$/.test(category.type),
      ) ?? [];

    if (motabilityCategories.length > 0) {
      const latest = motabilityCategories
        .map(cat => ({
          ...cat,
          year: parseInt(cat.type.replace("Motability", ""), 10),
        }))
        .sort((a, b) => b.year - a.year)[0];
      return latest.type;
    }

    throw new Error("No valid Motability product category found");
  }

  return ProductCategoryType.PreTest;
};
